import { withRouter } from "react-router-dom";
import Admin from "../../components/auth/Admin";
import CompanyDetails from "../../components/CompanyDetails";

const CompanyDetail = (props) => {
  const company = props.location.state;
  console.log(company);
  return (
    <Admin>
      <CompanyDetails companyData={company} />
    </Admin>
  );
};

export default withRouter(CompanyDetail);
